<template>
  <div
    class="h-full flex flex-col relative overflow-auto bg-premium"
    data-test-id="purchase-premium-ntf-modal"
  >
    <PremiumPaywall
      v-if="self.page === 'paywall' && self.packageSelected"
      v-model:package-selected="self.packageSelected"
      :feature="feature"
      :package-list="self.packageList"
      @close="emit('close')"
      @select="self.select"
      @next="self.nextPage"
    />
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

import PremiumPaywall from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/PremiumPaywall.vue';
import { useSelf } from '@/components/ntf-modal/components/ntf-premium/hooks/use-self/use-self';
import { SubscriptionFeature } from '@/components/subscription-promo-modal/helpers/subscription-promo-helper/type/type';
import { PromoShowPurchaseSource } from '@/helpers/gtm-triggers/gtm-triggers';

const props = defineProps({
  feature: {
    type: String as PropType<SubscriptionFeature>,
    default: undefined,
  },
  source: {
    type: String as PropType<PromoShowPurchaseSource>,
    required: true,
  },
});

const emit = defineEmits(['next', 'close', 'select']);

const self = useSelf({
  source: props.source,
  handleNext(packageSelected) {
    emit('next', packageSelected);
  },
  handleClose() {
    emit('close');
  },
  handleSelect(packageSelected) {
    emit('select', packageSelected);
  },
});

self.init();
</script>
